import { Route, Routes } from "react-router-dom";

import AuthGate from "@/components/AuthGate";
import Layout from "@/components/Layout";
import AirLogiImportPage from "@/pages/AirLogiImportPage";
import DashboardPage from "@/pages/DashboardPage";
import ErrorsPage from "@/pages/ErrorsPage";
import FulfillmentPage from "@/pages/FulfillmentPage";
import LoginPage from "@/pages/LoginPage";
import OrdersFetchPage from "@/pages/OrdersFetchPage";
import OrdersListPage from "@/pages/OrdersListPage";
import PrintJobPage from "@/pages/PrintJobPage";
import ShippingCheckPage from "@/pages/ShippingCheckPage";

function StubPage({ title }: { title: string }) {
  return (
    <div className="card">
      <h2 className="text-xl font-bold text-brand-primary mb-2">{title}</h2>
      <p className="text-gray-500 text-sm">
        この画面は Phase 2 で実装予定です。
      </p>
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<AuthGate />}>
        <Route element={<Layout />}>
          <Route index element={<DashboardPage />} />
          <Route path="fetch" element={<OrdersFetchPage />} />
          <Route path="allocate" element={<AirLogiImportPage />} />
          <Route path="print" element={<PrintJobPage />} />
          <Route path="fulfillment" element={<FulfillmentPage />} />
          <Route path="orders" element={<OrdersListPage />} />
          <Route path="errors" element={<ErrorsPage />} />
          <Route path="shipping-check" element={<ShippingCheckPage />} />
          <Route path="settings" element={<StubPage title="設定" />} />
          <Route path="*" element={<StubPage title="404 - Not Found" />} />
        </Route>
      </Route>
    </Routes>
  );
}
